import {
  action,
  computed,
  IReactionDisposer,
  makeObservable,
  observable,
  reaction,
} from 'mobx';
import { FilterInputValue } from '../../components/Module/Table/Filters/FilterInput';
import { FilterValue } from '../../components/Module/Table/Filters/FilterInput/types';

export interface OrderParam {
  direction: 'descend' | 'ascend';
  field: string;
}

export interface TableQueryOptions {
  page: number;
  pageSize: number;
  filterFields: FilterValue;
  order?: OrderParam;
}

export class TableQuery implements TableQueryOptions {
  @observable private _page: number;
  @observable private _pageSize: number;
  @observable private _filterFields: FilterValue;
  @observable private _order?: OrderParam;

  private _disposer?: IReactionDisposer;

  constructor({
    page,
    pageSize: pageSize,
    order,
    filterFields = {},
  }: TableQueryOptions) {
    this._page = page;
    this._pageSize = pageSize;
    this._order = order;
    this._filterFields = filterFields;

    makeObservable<TableQuery>(this);
  }

  @computed get pageSize() {
    return this._pageSize;
  }

  @computed get page() {
    return this._page;
  }

  @computed get order() {
    return this._order;
  }

  @computed get filterFields() {
    return this._filterFields;
  }

  @action setPage = (value: number) => {
    this._page = value;
  };

  @action setPageSize = (value: number) => {
    this._pageSize = value;
  };

  @action addFilterQuery = (key: string, value: FilterInputValue) => {
    this._filterFields = { ...this._filterFields, [key]: { ...value } };
  };

  @action mergeFilterQuery = (value: FilterValue) => {
    this._filterFields = { ...this._filterFields, ...value };
  };

  @action setOrder = (value?: OrderParam) => {
    this._order = value;
  };

  bind = () => {
    this._disposer = reaction(
      () => ({
        pageSize: this._pageSize,
        filterFields: this.filterFields,
      }),
      () => {
        this.setPage(1);
      },
    );
  };

  unbind = () => {
    this._disposer?.();
    this._disposer = undefined;
  };
}
